import { motion } from "framer-motion";

const Sticker = ({ children, className = "" }) => (
  <span className={`absolute z-20 rounded-full border-4 border-kadak px-4 py-1.5 font-bungee text-xs sm:text-sm sticker-shadow-sm ${className}`}>
    {children}
  </span>
);

export const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative overflow-hidden bg-pav pt-28 sm:pt-32 pb-16">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 sm:px-6 lg:grid-cols-[1.2fr_1fr]">
      <div className="relative z-10">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="font-bungee text-mirchi tracking-[0.35em] text-xs sm:text-sm"
        >
          THE VADA PAV, UNCURLED • EST. 2026
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-4 font-shrikhand text-6xl sm:text-7xl lg:text-8xl leading-[0.95] text-kadak"
        >
          Vada{" "}
          <span className="text-mirchi" style={{ textShadow: "4px 4px 0 #FFC226" }}>
            Sub
          </span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-5 max-w-xl text-base sm:text-lg font-medium text-kadak/80"
        >
          Mumbai's ₹20 icon, stretched into the world's favourite format. One long masala pav, one long
          garma-garam vada — <span className="font-bold text-kadak">poora Bombay, ek haath mein.</span>
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-8 flex flex-wrap items-center gap-4"
        >
          <a
            href="#elongification"
            data-testid="hero-elongify-cta"
            className="rounded-full border-4 border-kadak bg-mirchi px-7 py-3 font-bungee text-sm text-pav sticker-shadow transition-transform duration-150 hover:-translate-y-1 hover:-translate-x-1"
          >
            WATCH IT STRETCH
          </a>
          <a
            href="#menu"
            data-testid="hero-menu-cta"
            className="rounded-full border-4 border-kadak bg-pav px-7 py-3 font-bungee text-sm text-kadak sticker-shadow transition-transform duration-150 hover:-translate-y-1 hover:-translate-x-1"
          >
            SEE THE MENU
          </a>
        </motion.div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-8 inline-block -rotate-1 border-y-4 border-kadak bg-taxi px-4 py-2 font-bungee text-sm sm:text-base tracking-widest text-kadak"
        >
          LAMBA VADA. BADA MAZA.
        </motion.p>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.85, rotate: 8 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ type: "spring", stiffness: 90, damping: 14, delay: 0.2 }}
        className="relative mx-auto w-full max-w-md lg:max-w-none"
      >
        <motion.div
          animate={{ y: [0, -12, 0], rotate: [2, 3.5, 2] }}
          transition={{ repeat: Infinity, duration: 5, ease: "easeInOut" }}
          className="overflow-hidden rounded-3xl border-4 border-kadak sticker-shadow"
        >
          <img
            src="/assets/hero-sub.jpg"
            alt="The Vada Sub — one long garma-garam vada in a golden loaf"
            data-testid="hero-sub-photo"
            className="w-full"
          />
        </motion.div>
        <img
          src="/assets/logo-roundel.png"
          alt="Vada Sub roundel"
          className="absolute -bottom-8 -left-6 w-24 animate-spin-slow rounded-full border-4 border-kadak bg-pav sticker-shadow-sm sm:w-28"
        />
        <Sticker className="-left-3 -top-4 -rotate-6 bg-taxi text-kadak">100% VEG</Sticker>
        <Sticker className="-right-2 top-1/3 rotate-3 bg-gulabi text-kadak">GARMA GARAM</Sticker>
        <Sticker className="bottom-16 -right-3 -rotate-3 bg-chutney text-pav">HORN OK PAV</Sticker>
      </motion.div>
    </div>
    <div className="pointer-events-none absolute -right-10 bottom-6 hidden lg:block rotate-6 rounded-lg border-4 border-kadak bg-pav px-5 py-3 text-center sticker-shadow">
      <p className="font-anton text-lg leading-none">MUMBAI</p>
      <p className="font-anton text-sm text-mirchi">0 KM</p>
    </div>
  </section>
);
